module.exports = __webpack_public_path__ + "img/slide4.646fb6e6.png";